import { DeliveryManagement } from "@pages/myPage";
import React from "react";

const AddressPost = ({ setStep }: any) => {
  return (
    <div>
      <DeliveryManagement setStep={setStep} />
    </div>
  );
};

export default AddressPost;
